import { getlangFromCache, Languages } from "../../utils"
import { ActionTypes } from "../actions"

const lang = (
  state: Languages = getlangFromCache(),
  action: any
): Languages => {
  switch (action.type) {
    case ActionTypes.CHANGE_LANG:
      return action.lang
    default:
      return state
  }
}

export default lang
